<ion-menu contentId="main-content" type="overlay">

  <ion-content>
    <ion-list id="inbox-list" lines="unset">

      <ion-list-header>
        <div class="w-100 text-center mb-4">
          <img src="../../../../../assets/images/Logo_TELAR.ai.svg" alt="">
        </div>
      </ion-list-header>


      <div class="user-info d-flex align-items-center px-3 mb-3">
        <ion-avatar slot="start">
          <img alt="Silhouette of a person's head"
            [src]="'https://ui-avatars.com/api/?rounded=true&size=35&name=' + (user | async)?.displayName + '&background=3D4C86&color=fff'" />
        </ion-avatar>
        &nbsp;&nbsp;
        <ion-label>{{(user | async)?.firstName}} {{(user | async)?.lastName}}
          <p>{{(user | async)?.email}}</p>
        </ion-label>
      </div>

      <ng-container *ngFor="let p of appPages; let i = index">
        @if (p.children?.length) {
        <ion-accordion-group>
          <ion-accordion [value]="'p.title'">
            <ion-item slot="header">
              <ion-icon slot="start" [name]="p.icon" [src]="p.iconUrl"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              <ng-container *ngFor="let child of p.children">

                <ion-menu-toggle auto-hide="false">
                  @if (child.actionClick) {
                  <ion-item button (click)="child.actionClick()">
                    <ion-icon slot="start" [name]="child.icon" [src]="child.iconUrl"></ion-icon>
                    <ion-label>{{ child.title }}</ion-label>
                  </ion-item>
                  } @else {
                  <ion-item routerDirection="root" [routerLink]="[child.url]" lines="none" detail="false"
                    routerLinkActive="selected">
                    <ion-icon slot="start" [name]="child.icon" [src]="child.iconUrl"></ion-icon>
                    <ion-label>{{ child.title }}</ion-label>
                  </ion-item>
                  }

                </ion-menu-toggle>

              </ng-container>
            </div>

          </ion-accordion>
        </ion-accordion-group>

        } @else {
        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
            routerLinkActive="selected">
            <ion-icon slot="start" [name]="p.icon" [src]="p.iconUrl"></ion-icon>
            <ion-label>{{ p.title }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
        }


      </ng-container>


      <div class="sidemenu-footer">
      @if (currentUser?.organizations?.length! > 1) {

  
      <ion-menu-toggle>
        <ion-item [button]="true" routerLink="/auth/select-organization">
          <ion-icon slot="start" name="sync-outline"></ion-icon>
          <ion-label>Cambiar Organización</ion-label>
        </ion-item>
      </ion-menu-toggle>
      }


      <ion-menu-toggle>
        <ion-item [button]="true" (click)="logout()">
          <ion-icon slot="start" name="log-out-outline"></ion-icon>
          <ion-label>Cerrar sesión</ion-label>
        </ion-item>
      </ion-menu-toggle>
      </div>

    </ion-list>

  </ion-content>
</ion-menu>